<template>
  <h5
    class="title4-container"
    :class="device.isMobile ? 'title4-container-mobile' : ''"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
      backgroundImage: content.textStyle.backgroundImage ? `url(${content.textStyle.backgroundImage})` : '',
      width: (typeof content.textStyle.width === 'string') ? content.textStyle.width :
        (typeof content.textStyle.width === 'number') ? (content.textStyle.width + 'rem') : '',
      marginTop: (content.textStyle.marginTop + 'rem') || '',
      marginBottom: (content.textStyle.marginBottom + 'rem') || '',
      padding: (typeof content.textStyle.padding === 'number' && (content.textStyle.padding + 'rem')) || '',
      paddingTop: (typeof content.textStyle.paddingTop === 'number' && (content.textStyle.paddingTop + 'rem')) || '',
      paddingBottom: (typeof content.textStyle.paddingBottom === 'number' && (content.textStyle.paddingBottom + 'rem')) || '',
      paddingLeft: (typeof content.textStyle.paddingLeft === 'number' && (content.textStyle.paddingLeft + 'rem')) || '',
      paddingRight: (typeof content.textStyle.paddingRight === 'number' && (content.textStyle.paddingRight + 'rem')) || '',
      borderRadius: (typeof content.textStyle.borderRadius === 'number' && (content.textStyle.borderRadius + 'rem')) || '',
    }"
    v-html="content.text"
  ></h5>
</template>
<script>
/*
标题-4
*/
export default {
  name: "title-4",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title4-container{
  width: calc(100% - 48rem);
  margin: 20rem auto;
  font-size: 20rem;
  color: #333;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-weight: bold;
  text-indent: 2em;
}
.title4-container-mobile{
  margin: 66rem auto 20rem;
  font-size: 28rem;
}
</style>